/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

// TODO: assign to correct module
import { useEffect, useRef, useState } from "react";
import { ATTACH_ACCEPT, ATTACH_MAX_MB, validateAttachment, attachmentSignedUrl } from "../utils/ticketService.js";

// Pick files to attach (the parent owns the File[] in `files`).
export function FilePicker({ files, setFiles, disabled }) {
  const ref = useRef(null);
  const [err, setErr] = useState(null);

  function add(list) {
    setErr(null);
    const next = [...files];
    for (const f of list) {
      const bad = validateAttachment(f);
      if (bad) { setErr(bad); continue; }
      if (!next.some((x) => x.name === f.name && x.size === f.size)) next.push(f);
    }
    setFiles(next);
  }

  return (
    <div>
      <input
        ref={ref}
        type="file"
        multiple
        accept={ATTACH_ACCEPT.join(",")}
        style={{ display: "none" }}
        onChange={(e) => { add(e.target.files); e.target.value = ""; }}
      />
      <button type="button" className="secondary" disabled={disabled} onClick={() => ref.current?.click()}>
        Attach files
      </button>
      <span className="muted" style={{ fontSize: 12, marginLeft: 10 }}>Images, PDF, Word, txt · max {ATTACH_MAX_MB} MB each</span>
      {files.length > 0 && (
        <ul style={{ listStyle: "none", padding: 0, margin: "10px 0 0", display: "flex", flexWrap: "wrap", gap: 8 }}>
          {files.map((f, i) => (
            <li key={i} style={{ display: "flex", alignItems: "center", gap: 6, background: "var(--sunken, #eef0f4)", borderRadius: 8, padding: "5px 9px", fontSize: 12 }}>
              <span>{f.name}</span>
              <span className="muted">{(f.size / 1024).toFixed(0)} KB</span>
              <button type="button" className="link" style={{ padding: 0 }} onClick={() => setFiles(files.filter((_, j) => j !== i))} aria-label={`Remove ${f.name}`}>✕</button>
            </li>
          ))}
        </ul>
      )}
      {err && <p className="error" style={{ fontSize: 12, marginTop: 6 }}>{err}</p>}
    </div>
  );
}

// Render saved attachments ({path,name,type,size}) as links via signed URLs.
export function AttachmentList({ attachments }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
      {attachments.map((a, i) => <AttachmentChip key={a.path || i} att={a} />)}
    </div>
  );
}

function AttachmentChip({ att }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true;
    if (att.path) attachmentSignedUrl(att.path).then((u) => { if (alive) setUrl(u); });
    return () => { alive = false; };
  }, [att.path]);

  const isImg = (att.type || "").startsWith("image/");
  const inner = (
    <span style={{ display: "flex", alignItems: "center", gap: 6, background: "rgba(127,127,127,.14)", borderRadius: 8, padding: "5px 9px", fontSize: 12 }}>
      {isImg && url
        ? <img src={url} alt="" style={{ width: 28, height: 28, borderRadius: 4, objectFit: "cover" }} />
        : <span aria-hidden="true">📎</span>}
      <span>{att.name}</span>
    </span>
  );
  return url
    ? <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>{inner}</a>
    : inner;
}
